const riot = require('riot');

riot.tag2('page-projects', '<div class="f s-full"> <div class="box-shadow" if="{!app.useragent.isMobile}" ref="sidebar" data-is="module-sidebar"></div> <div class="f fclm s-full p40 overflow-y-scroll s-p12"> <div class="f fm fbw mb32 s-flex-column s-ft s-mb12"> <label class="f fm w320 py7 pr4 pl10 bg-white rounded-4 lh15 s-w-full s-mb8"><i class="icon-search fs16 text-label_low mr8"></i> <input class="w-full fs11" ref="search" type="text" oninput="{onInput}" placeholder="プロジェクトを探す"><i class="icon-close fs16 text-label_low cursor-pointer ml8" if="{refs.search.value}" onclick="{onDeleteText}"></i> </label><a href="/projects/new"> <button class="button primary_fill f fm px12 py9"><i class="icon-add fs16 text-white mr4"></i> <div class="text-white lh15 letter-spacing-0_03em">プロジェクトを追加</div> </button></a> </div> <div class="f fclm s-full bg-white rounded-4 box-shadow overflow-scroll"> <table class="w-full border-spacing-0 border-collapse-collapse"> <thead class="sticky t0 r0 l0 z10"> <tr class="bg-white"> <th class="pl24 py20 text-left border-bottom fw4 fs12 lh15 text-label_low" each="{th in app.data.table.project}">{th} </th> </tr> </thead> <tbody> <tr class="border-bottom cursor-pointer hover-trigger hover-bg-label_pale transition" each="{project, index in displayProjects}" onclick="{onSelect}"> <td class="min-width-300 pl24 py18"> <div class="f fm"> <div class="flex-fixed s8 circle mr4" riot-style="background-color: {project.data.color || app.utils.defaultColor};"></div> <div class="fs12 lh15 fw4" riot-style="color: {project.data.color || app.utils.defaultColor};">{project.data.name}</div> <div class="pl4 fs12 lh15 fw4 text-label_medium" if="{project.data.archived}">(アーカイブ済み)</div> </div> </td> <td class="f fm min-width-175 pl24 py18"> <div class="flex-fixed s20 square rounded-4 mr4" riot-style="background-color: {project.data.color || app.utils.defaultColor};"></div> <div class="text-label_high fs12 lh15">{project.data.color}</div> </td> </tr> </tbody> </table> </div> <div if="{app.useragent.isMobile}" data-is="module-tabbar"></div> </div> </div>', 'page-projects,[data-is="page-projects"]{display:block}', '', function(opts) {
    this.preload = async () => {
      var promises = [
        app.store.collection('projects').fetch({ relation: true }),
      ];

      var [projects] = await Promise.all(promises);

      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);

      return {
        projects,
        displayProjects: projects,
      };
    };

    this.on('show', () => {
      requestAnimationFrame(() => {
        this.refs.search.focus();
      });
    });

    this.onSelect = (e) => {

      spat.router.push(`/projects/${e.item.project.id}`);
    };

    this.dummyData = { operatingVolume: '60', upperLimit: '100' };

    this.users = [
      { image: '/images/kenkyo.png'},
      { image: '/images/kenkyo.png'},
      { image: '/images/kenkyo.png'},
    ];

    this.getOperationRate = () => {
      return Math.round(this.dummyData.operatingVolume / this.dummyData.upperLimit * 100);
    };

    this.onInput = (e) => {
      e.preventUpdate = true;
      this.debounceSearch();
    };

    this.debounceSearch = _.debounce(() => {
      var value = this.refs.search.value;

      const KEYWORD = value.toLowerCase();

      this.displayProjects = this.projects.map(project => {

        const index = project.data.name.toLowerCase().indexOf(KEYWORD);

        return { index, project };

      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index).map(item => item.project);

      this.update();
    }, 64);

    this.onDeleteText = () => {
      this.refs.search.value = '';
      this.debounceSearch();
      this.update();
    };
});